var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cityId && _vm.statModalOpen && _vm.waitingStatistics && _vm.cookieStatNotificationDidntSeen)?_c('stat-notification-modal',{attrs:{"city-id":_vm.cityId},on:{"close":function($event){_vm.statModalOpen = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }